import { http } from '@/lib/http'
import type { Channel, ChannelMessage, ChannelAttachment } from './channels'

export interface DmChannel extends Channel {
  type: 'dm';
}

export async function listDmChannels(workspaceId: string, authToken?: string | null): Promise<DmChannel[]> {
  const res = await http.get<DmChannel[]>(`/workspaces/${workspaceId}/channels?type=dm`, { authToken })
  return res.data
}

export async function findOrCreateDm(workspaceId: string, otherUserId: string, otherUserName?: string, authToken?: string | null): Promise<DmChannel> {
  const res = await http.post<DmChannel>(`/workspaces/${workspaceId}/channels`, {
    type: 'dm',
    memberIds: [otherUserId],
    otherUserName,
  }, { authToken })
  return res.data
}

// Re-export message functions from channels — they work on any channel ID
export { listMessages, sendMessage, markChannelRead, deleteMessage } from './channels'
export type { ChannelMessage, ChannelAttachment }
